import React from "react";

const Help = () => (
    <p>
        Questions? Get in touch any time:
        {" "}
        <a href="mailto:listed@standardnotes.org?subject=Listed Help">listed@standardnotes.org</a>
        .
    </p>
);

export default Help;
